import React from "react";
import "./styles.css";
import PodcastsImg from "../../assets/img/podcasts.png";
import { podcastsPlatforms, podcastsArray } from "../../constants/contents";

function Podcast() {
  return (
    <div className="podcast">
      <div className="podcast__intro">
        <h1>Encuentra nuestro podcast en las siguientes plataformas:</h1>
        <span className="podcast__platforms">
          {podcastsPlatforms.map((podcastPlatform) => (
            <img src={podcastPlatform} alt="podcast plataform" />
          ))}
        </span>
        <img src={PodcastsImg} alt="woman and man listening podcasts" />
      </div>
      <div className="podcast__content">
        {podcastsArray.map((podcastLink) => (
          <iframe
            title="tramyPodcast"
            src={podcastLink}
            width="80%"
            height="232"
            frameBorder="0"
            allowfullscreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          ></iframe>
        ))}
      </div>
    </div>
  );
}

export default Podcast;
